import Main from './PdcaMain'
import New from './PdcaNew'
import Edit from './PdcaEdit'
import Show from './PdcaShow'

export default {
  Main,
  New,
  Edit,
  Show,
}
